/* eslint-disable max-classes-per-file */
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { HandelssortimentsgruppDTO } from "~app/common/models/common/HandelssortimentsgruppDTO";
import { MarknadsomradeDTO } from "~app/common/models/common/MarknadsomradeDTO";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { Forsorjningskalla, IForsorjningskalla, IForsorjningsrad } from "../../../../common/models/forsorjningskalla";
import { ILeveransrad } from "../../../../common/models/leveransrad";

export interface IGridPeriod {
    type: string;
    from: Date;
    to: Date;
    periodMonth: Date;
}

export class GridPeriod implements IGridPeriod {
    type: string;
    from: Date;
    to: Date;
    periodMonth: Date;
}

export interface IOrderBasdata {
    marknadsomraden: MarknadsomradeDTO[];
    omraden: SelectionItem[];
    handelssortimentsgrupper: HandelssortimentsgruppDTO[];
    handelssortiment: SelectionItem[];
}

export interface IOrderKundorderSearchResponse {
    kundorderrader: IOrderKundorderrad[];
    totaltAntalArbetsdagarInnevarandeManad: number;
    passeradeAntalArbetsdagarInnevarandeManad: number;
}

export interface IUpdatedForsorjning {
    forsorjningskalla: Forsorjningskalla;
    orderradId: number;
    forsorjningsgrupp: IForsorjningsradResponse[];
}

export class UpdatedForsorjning implements IUpdatedForsorjning {
    forsorjningskalla: IForsorjningskalla;
    orderradId: number;
    forsorjningsgrupp: IForsorjningsradResponse[] = [];
}

export class LevorderLeveransrad implements ILevorderLeveransrad {
    datum: Date;
    kvantitet: number;
    forsorjningsrader: IForsorjningsrad[];
}

export interface IFordelaLeveransraderRequest {
    orderradId: number;
    isLeverantorsorder: boolean;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export interface IFordelaForsorjningsraderResponse {
    orderradId: number;

    forsorjningsrader: IForsorjningsradResponse[];
}

export interface IForsorjningsradResponse {
    datum: Date;
    kvantitet: number;
    orderradId: number;

}

export interface IFordelaLeveransraderResponse {
    leveransrader: ILeveransrad[];
    orderradId: number;
}

export interface IFordelaLevorderLeveransraderResponse {
    leveransrader: ILeveransrad[];
    orderradId: number;
}

export interface ILevorderLeveransrad {
    datum: Date;
    kvantitet: number;
    forsorjningsrader: IForsorjningsrad[];
}

export class FordelaLeveransraderRequest implements IFordelaLeveransraderRequest {
    orderradId: number;
    isLeverantorsorder: boolean;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export class Fordelningstyp {
    static get period(): string { return "PERIOD"; }
    static get manad(): string { return "MANAD"; }
    static get vecka(): string { return "VECKA"; }
}

export class FordelaForsorjningsraderRequest implements IFordelaForsorjningsraderRequest {
    levorderradId: number;
    kundorderradId: number;
    forsorjningskallaId: number;
    forsorjningskallaTyp: string;
    periodStart: Date;
    periodSlut: Date;
    orderId: number;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export interface IFordelaForsorjningsraderRequest {
    levorderradId: number;
    kundorderradId: number;
    forsorjningskallaId: number;
    forsorjningskallaTyp: string;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export interface IOrderLeverantorsorderradBase {
    id: number;
    rowVersion: string;
    leverantorsorderrad: IOrderLevorderDetailBase;
}
export interface IOrderLeverantorsorderrad extends IOrderLeverantorsorderradBase {
    id: number;
    orderNr: string;
    leverantorId: string;
    leverantor: string;
    avtalsansvarig: string;
    status: string;
    kontaktinformation: string;
    iBy: string;
    uBy: string;
    leverantorsorderrad: IOrderLeverantorsorderradDetail;
}

export interface IOrderKund {
    id: number;
    namn: string;
}

export interface IOrderAvtalsansvarig {
    id: number;
    namn: string;
}

export interface IOrderHandelssortiment {
    id: number;
    namn: string;
    aktiv: boolean;
}

export interface IOrderMottagningsplats {
    id: number;
    namn: string;
    aktiv: boolean;
}

export interface IOrderLeveransrad {
    id: number;
    datum: Date;
    kvantitet: number;
    transporteratKvantitet: number;
    forsorjningsrader: IForsorjningsrad[];
    orderradId: number;
}

export interface IOrderKundorderDetailBase extends IOrderRowVersion {
    leveransrader: ILeveransrad[];
}

export interface IOrderLevorderDetailBase extends IOrderRowVersion {
    levorderLeveransrader: ILeveransrad[];
}

export interface IOrderKundorderradDetail extends IOrderKundorderDetailBase {
    kvantitet: number;
    periodtyp: string;
    periodFrom: Date;
    periodTom: Date;
    handelssortiment: IOrderHandelssortiment;
    produktgrupp: IOrderProduktgrupp;
    mottagningsplats: IOrderMottagningsplats;
    forsorjningskallor: Forsorjningskalla[];
    overenskommenKvantitetLeveransrad: number;
}

export interface IOrderSaveResponse {
    changedOrders: IOrderOrderRowVersion[];
}

export interface IOrderRowVersion {
    id: number;
    rowVersion: string;
}

export interface IOrderOrderrad extends IOrderRowVersion {
    leveransrader: IChangedLeveransrad[];
}

export interface IOrderOrderRowVersion {
    orderrader: IOrderOrderrad[];
}

export interface IChangedLeveransrad extends IOrderRowVersion {
    forsorjningsrader: IChangedForsorjningsrad[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IChangedForsorjningsrad extends IOrderRowVersion {
}

export interface IOrderKundorderradBase {
    id: number;
    rowVersion: string;
    kundorderrad: IOrderKundorderDetailBase;
}

export interface IOrderKundorderrad extends IOrderKundorderradBase {
    id: number;
    ordernummer: string;
    kundordertyp: string;
    beskrivning: string;
    kommentar: string;
    mattslag: string;
    kund: IOrderKund;
    avtalsansvarig: IOrderAvtalsansvarig;
    kundorderrad: IOrderKundorderradDetail;
}

export interface IOrderProduktionsomrade {
    kundorderrader: IOrderKundorderrad;
}

export interface IOrderProduktionsomraderad extends IOrderKundorderradBase {
    id: number;
    ordernummer: string;
    kundordertyp: string;
    beskrivning: string;
    mattslag: string;
    kund: IOrderKund;
    avtalsansvarig: IOrderAvtalsansvarig;
    kundorderrad: IOrderKundorderradDetail;
}

export interface IForsorjningsradLevorder {
    forsorjningskallaId: number;
    id: number;
    rowVersion: string;
    typ: string;
    andel: number;
    dagkvantitet: number;
    transporteratKvantitet: number;
}

export interface IOrderLevorderLeveransrad {
    id: number;
    datum: Date;
    kvantitet: number;
    transporteratKvantitet: number;
    forsorjningsrader: IForsorjningsrad[];
}

export interface IOrderProduktgrupp {
    id: string;
    namn: string;
}

export interface IOrderHandelssortimentsgrupp {
    id: string;
    namn: string;
}

export interface IOrderLeverantorsorderradDetail extends IOrderLevorderDetailBase {
    kvantitet: number;
    periodFrom: Date;
    periodTom: Date;
    handelssortimentsgrupp: IOrderHandelssortimentsgrupp;
    forsorjningskallor: Forsorjningskalla[];
    mattslag: string;
}

export interface IOrderLeverantorsorderSearchResponse {
    leverantorsorderrader: IOrderLeverantorsorderrad[];
    totaltAntalArbetsdagarInnevarandeManad: number;
    passeradeAntalArbetsdagarInnevarandeManad: number;
}
export interface IOrderProduktionsomradeSearchResponse {
    kundorderrader: IOrderKundorderrad[];
    totaltAntalArbetsdagarInnevarandeManad: number;
    passeradeAntalArbetsdagarInnevarandeManad: number;
}

export interface IAvtalsansvarig {
    id: number;
    name: string;
    aktiv: boolean;
}

export class Avtalsansvarig implements IAvtalsansvarig {
    id: number;
    name: string;
    aktiv: boolean;

    static createInstance(name: string, id: number, aktiv: boolean) {

        const avtalsansvarig = new Avtalsansvarig();

        avtalsansvarig.name = name;
        avtalsansvarig.id = id;
        avtalsansvarig.aktiv = aktiv;
        return avtalsansvarig;
    }

    static createInstanceFromTypeAhead(typeahead: ITypeAheadResult) {

        if (typeahead == null) {
            return null;
        }

        const avtalsansvarig = new Avtalsansvarig();

        avtalsansvarig.name = typeahead.namn;
        avtalsansvarig.id = typeahead.id;
        avtalsansvarig.aktiv = typeahead.aktiv;
        return avtalsansvarig;
    }

    static getListfromTypeAhead(typeaheadList: ITypeAheadResult[]) {

        const avtalsansvarigList: Avtalsansvarig[] = [];
        typeaheadList.forEach(typeahead => {
            avtalsansvarigList.push(this.createInstanceFromTypeAhead(typeahead));
        });

        return avtalsansvarigList;
    }
}
